// extracted by mini-css-extract-plugin
module.exports = {"PageServerError":"gVUN72KB","container":"NFAKT9Ty","img":"uUIvtkc_","content":"__1Jmh0Ax3","text":"EbQZzc6L","btnGroup":"KGiAGj7u"};